import React from 'react';
import { Box } from '@mui/material';
import { SystemSettingsCard, SystemSettingsHeader } from './components';
import { SYSTEM_SETTINGS_ITEMS } from './constants';

export const SystemSettings = () => {
  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', gap: 2.5 }}>
      <SystemSettingsHeader />

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)',
          },
          gap: 2.5,
          pt: 1,
        }}
      >
        {SYSTEM_SETTINGS_ITEMS.map((item) => (
          <SystemSettingsCard key={item.id} item={item} />
        ))}
      </Box>
    </Box>
  );
};
